__turbopack_context__.v({
  "apps-card-title": "I1f7WG_apps-card-title",
});
